// Mirror of backend SUBJECT_TOPICS (server.py).
// Used as a synchronous fallback so the Topic dropdown never appears empty,
// even if the /api/questions/topics call is slow, fails, or hasn't completed
// yet. Backend remains the source of truth — the API result is merged on top.
export const SUBJECT_TOPICS = {
  Math: [
    "Algebra", "Linear Relations", "Geometry", "Trigonometry", "Calculus",
    "Statistics", "Probability", "Polynomials", "Exponents", "Graphing",
    "Number Theory", "Functions", "Sequences and Series", "Vectors", "Matrices",
  ],
  Physics: [
    "Mechanics", "Kinematics", "Dynamics", "Thermodynamics", "Electromagnetism",
    "Electricity", "Magnetism", "Optics", "Waves", "Modern Physics",
    "Quantum Mechanics", "Relativity", "Energy", "Forces", "Fluids",
  ],
  Chemistry: [
    "Atomic Structure", "Periodic Table", "Chemical Bonding", "Chemical Reactions",
    "Stoichiometry", "Acids and Bases", "Organic Chemistry", "Thermochemistry",
    "Electrochemistry", "Solutions", "Gases", "Equilibrium", "Kinetics",
  ],
  Biology: [
    "Cell Biology", "Genetics", "Evolution", "Ecology", "Human Anatomy",
    "Physiology", "Plants", "Microbiology", "Biochemistry", "DNA and RNA",
    "Photosynthesis", "Respiration", "Immune System", "Nervous System",
  ],
  English: [
    "Grammar", "Vocabulary", "Reading Comprehension", "Literature", "Writing",
    "Poetry", "Punctuation", "Spelling", "Synonyms and Antonyms",
    "Figures of Speech", "Sentence Structure",
  ],
  History: [
    "Ancient History", "Medieval History", "Modern History", "World War I",
    "World War II", "American History", "European History", "Asian History",
    "Renaissance", "Industrial Revolution", "Cold War", "Colonialism",
  ],
  Geography: [
    "Physical Geography", "Human Geography", "Climate", "Countries", "Capitals",
    "Continents", "Oceans", "Mountains", "Rivers", "Population", "Maps",
    "Natural Resources", "Biomes",
  ],
};

export function fallbackTopics(subject) {
  return SUBJECT_TOPICS[subject] ? [...SUBJECT_TOPICS[subject]].sort() : [];
}
